import { Component, OnInit } from '@angular/core';
import { Permissions } from "../../../../Models/Permissions";
import { PermissionService } from '../../../../Services/permission.service';
import { PassportAdminService } from '../Services/passport.admin.service';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';

@Component({
    selector: 'aw-applications',
    templateUrl: './applications.component.html',
    styleUrls: ['./applications.component.less'],
    imports: [MatButton, FormsModule, MatFormField, MatLabel, MatInput]
})
export class ApplicationsComponent implements OnInit {
  public applications: any[];
  public editingApplication: any;
  public isReadOnly: boolean;

  constructor(
    private service: PassportAdminService,
    private permissionService: PermissionService) { }

  public ngOnInit(): void {
    this.getApplications();
    this.isReadOnly = this.permissionService.hasPermission(Permissions.passportReadOnly);
  }

  private getApplications(): void {
    this.service
      .getApplications()
      .subscribe(applications => this.applications = applications);
  }

  public edit(app: any): void {
    this.editingApplication = JSON.parse(JSON.stringify(app));
  }

  public onSubmit(editingApplication, settingsForm): void {
    if (settingsForm.form.invalid) {
      return;
    }

    this.service.saveApplication(editingApplication)
      .subscribe(response => this.getApplications());
    this.editingApplication = null;
  }

  public delete(app: any): void {
    this.service.deleteApplication(app)
      .subscribe(response => this.getApplications());
  }
}
